
export class ClubCartDetailProductPrice {
	constructor(data) {
		this.id = data && data.id ? data.id : undefined;
        this.price = data && data.price ? data.price : undefined;
        this.discounted_price = data && data.discounted_price ? data.discounted_price : undefined;
        this.tax = data && data.tax ? data.tax : undefined;
        this.quantity = data && data.quantity ? data.quantity : undefined;
    }
}